import { useCallback, useEffect, useState } from 'react';
import { UseFormGetValues } from 'react-hook-form';
import { Logger } from 'src/utils/Logger';
import { WebsiteGraderAddCompetitor } from '../../Utils';
import { PollCompetitorGrade } from '../../PollWebsiteGrade';
import { useWebsiteGraderContext } from 'src/components/providers/websiteGrader';

const captchSrc = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;

type ReturnType = {
  disabled: boolean;
  processing: boolean;
  onSubmit: () => void;
};

export const useSubmitCompetitorForm = (getValues: UseFormGetValues<{ website: string; uuid: string }>): ReturnType => {
  const [disabled, setDisabled] = useState(false);
  const [processing, setProcessing] = useState(false);
  const context = useWebsiteGraderContext();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = captchSrc;
    document.body.appendChild(script);
  }, []);

  const onSubmit = useCallback(async () => {
    // set states
    setDisabled(true);
    setProcessing(true);
    //
    Logger.trace(
      'onSubmit:competitor:before',
      { website: getValues('website'), uuid: getValues('uuid') },
      'WebsiteGraderCompetitorForm'
    );

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY!, { action: 'submit' }).then(async (recaptcha) => {
        // post competitor with recaptcha
        try {
          const response: { id: number } = await WebsiteGraderAddCompetitor(
          {
              uuid: getValues('uuid'),
              website: getValues('website'),
            },
            recaptcha
          );
          Logger.trace(
            'onSubmit:competitor:before:competitor-grade-poll',
            { website: getValues('website'), response },
            'WebsiteGraderCompetitorForm'
          );
          const competitorGrade = await PollCompetitorGrade(getValues('uuid'), response.id);
          Logger.trace(
            'onSubmit:competitor:after:competitor-grade-poll',
            { website: getValues('website'), response, competitorGrade },
            'WebsiteGraderCompetitorForm'
          );
          context.setCompetitorScore({ ...competitorGrade });
        } catch (error: Error | unknown) {
          if (error instanceof Error) {
            context.setError(error.message);
          } else {
            context.setError('An unknown error occurred');
          }
        } finally {
          setProcessing(false);
        }
      });
    });
  }, [context]);

  return { disabled, processing, onSubmit };
};
